import appBranding from '@happylife-a/branding';

export const fieldTrackings = {
  AdminDashboard: appBranding.fields.env.Tracking.Admin,
  SellerDashboard: appBranding.fields.env.Tracking.Seller,
  Corporate: appBranding.fields.env.Tracking.Corporate,
  MaaS: appBranding.fields.env.Tracking.Maas,
  WebApp: appBranding.fields.env.Tracking.WebApp,
};
